import { render } from "./HomeAbout.vue?vue&type=template&id=431fad0b"
import script from "./HomeAbout.vue?vue&type=script&lang=js"
export * from "./HomeAbout.vue?vue&type=script&lang=js"
script.render = render

export default script